import { createContext } from 'react';

const clientContext = createContext();

export default clientContext;
